import styled from 'styled-components';

export const Date_loans = styled.div`

`;